<div class="app-page-container">

  <div *ngIf="loading" class="d-flex app-text-success justify-content-center align-items-center">
    <span class="spinner-border spinner-border-sm mr-1"></span>
    Loading Import Report Emails...
  </div>

  <section *ngIf="!loading">
    <h1 class="mb-1" style="line-height: 1">Import Report Emails</h1>
    <p class="text-muted mb-4">
      Each email receives a report of recent import failures for the categories it's subscribed to.
      No email is sent when there are no failures in its categories.
    </p>

    <!-- ADD -->
    <form class="card mb-4" (ngSubmit)="addRecipient()">
      <div class="card-header app-text-white app-bg-dark">Add Email</div>
      <div class="card-body">
        <div class="form-group">
          <label for="newEmail">Email</label>
          <input
            id="newEmail"
            name="newEmail"
            class="form-control"
            type="email"
            placeholder="name@example.com"
            [(ngModel)]="newRecipient.email"
            [disabled]="saving"
          />
        </div>
        <label class="d-block">Categories</label>
        <div class="d-flex flex-wrap mb-3">
          <div *ngFor="let category of categories" class="form-check mr-4" [title]="categorySourcesTitle(category)">
            <input
              class="form-check-input"
              type="checkbox"
              [id]="'new-' + category"
              [name]="'new-' + category"
              [(ngModel)]="newRecipient.categories[category]"
              [disabled]="saving"
            />
            <label class="form-check-label" [for]="'new-' + category">{{ categoryLabel(category) }}</label>
          </div>
        </div>
        <button class="btn app-btn-success" type="submit" [disabled]="saving">Add</button>
      </div>
    </form>

    <!-- LIST -->
    <div *ngIf="!recipients.length" class="text-muted">
      No emails configured. Import failure reports won't be sent until at least one email is added.
    </div>

    <table *ngIf="recipients.length" class="table recipients-table">
      <thead>
        <tr>
          <th>Email</th>
          <th *ngFor="let category of categories" class="text-center" [title]="categorySourcesTitle(category)">
            {{ categoryLabel(category) }}
          </th>
          <th class="actions-column"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let recipient of recipients">

          <!-- VIEW -->
          <ng-container *ngIf="editingId !== recipient.id">
            <td class="align-middle text-break">{{ recipient.email }}</td>
            <td *ngFor="let category of categories" class="text-center align-middle">
              <mat-icon *ngIf="recipient.categories?.includes(category)" class="app-text-success">check</mat-icon>
            </td>
            <td class="align-middle text-right text-nowrap">
              <ng-container *ngIf="confirmingDeleteId !== recipient.id">
                <button class="btn btn-sm app-btn-neutral mr-2" type="button" (click)="startEdit(recipient)" [disabled]="saving">Edit</button>
                <button class="btn btn-sm app-btn-neutral" type="button" (click)="confirmDelete(recipient)" [disabled]="saving">Delete</button>
              </ng-container>
              <ng-container *ngIf="confirmingDeleteId === recipient.id">
                <span class="mr-2">Remove?</span>
                <button class="btn btn-sm btn-danger mr-2" type="button" (click)="deleteRecipient(recipient)" [disabled]="saving">Delete</button>
                <button class="btn btn-sm app-btn-neutral" type="button" (click)="cancelDelete()" [disabled]="saving">Cancel</button>
              </ng-container>
            </td>
          </ng-container>

          <!-- EDIT -->
          <ng-container *ngIf="editingId === recipient.id">
            <td class="align-middle">
              <input
                class="form-control form-control-sm"
                type="email"
                [name]="'edit-email-' + recipient.id"
                [(ngModel)]="editDraft.email"
                [disabled]="saving"
              />
            </td>
            <td *ngFor="let category of categories" class="text-center align-middle">
              <input
                type="checkbox"
                [name]="'edit-' + recipient.id + '-' + category"
                [(ngModel)]="editDraft.categories[category]"
                [disabled]="saving"
              />
            </td>
            <td class="align-middle text-right text-nowrap">
              <button class="btn btn-sm app-btn-success mr-2" type="button" (click)="saveEdit(recipient)" [disabled]="saving">Save</button>
              <button class="btn btn-sm app-btn-neutral" type="button" (click)="cancelEdit()" [disabled]="saving">Cancel</button>
            </td>
          </ng-container>

        </tr>
      </tbody>
    </table>
  </section>

</div>
